export default __webpack_public_path__ + "static/media/glenn lvey.ee8362b5.jpg";